import { Box, Flex, Heading } from "@chakra-ui/react"
import { PublicationBlockTextPublic } from "../../client"
import { Prose } from "../UI/prose"

const TextBlock = ({ data }: { data: PublicationBlockTextPublic }) => {
    return (
        <Flex 
            p={data.is_box ? 6 : 0} my={10} 
            position="relative" 
            direction="column" 
            alignItems={data.is_footnote ? "flex-end" : undefined}
        >
            <Box w={data.is_footnote ? {base: "full", md: "fit-content"} : "full"}>
                {data.is_box &&
                    <Box
                        _before={{
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "3em",
                            borderTop: "3px solid",
                            borderColor: "main",
                        }}
                        _after={{
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "3em",
                            borderLeft: "3px solid",
                            borderColor: "main",
                        }}
                    />
                }
            
                {/* Title */}
                {data.title &&
                    <Heading size="md" mb={4} color={data.is_footnote ? "dimgray" : "black"}>{data.title}</Heading>
                }

                {/* Text */}
                {data?.text &&
                    <Prose
                        w="full"
                        maxW="none"
                        css={{
                            "& > p:first-of-type": {
                                margin: 0,
                            },
                            "& a": {
                                color: data.is_footnote ? "dimgray" : "black",
                                textDecor: "none",
                            },
                        }}
                        color={data.is_footnote ? "dimgray" : "black"}
                        dangerouslySetInnerHTML={{ __html: data.text }}
                    />
                }
            
                {data.is_box &&
                    <Box
                        _before={{
                            content: '""',
                            position: "absolute",
                            bottom: 0,
                            right: 0,
                            width: "3em",
                            borderBottom: "3px solid",
                            borderColor: "main",
                        }}
                        _after={{
                            content: '""',
                            position: "absolute",
                            bottom: 0,
                            right: 0,
                            height: "3em",
                            borderRight: "3px solid",
                            borderColor: "main",
                        }}
                    />
                }
            </Box>
        </Flex>
    )
}

export default TextBlock